import toast from "react-hot-toast";
import axiosInstance from "./Axios";
import { clientRoutes } from "../routes";
import { LocalStorageKeys } from "../helpers/common.utils";
import { LocalStorageHelpers } from "../helpers/localstorage.helpers";
import axios from "axios";

export class AgencyApi {
  static SearchAgencyList = async (search: string) => {
    try {
      const res = await axiosInstance.get(
        `agent/search-agencies?search=${search}`,
      );
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static getAgents = async (search: string = "") => {
    try {
      const res = await axiosInstance.get(`agency/agents`, {
        params: {
          page: 1,
          limit: 100,
          created_at: "desc",
          search: search,
          agency_id: "",
        },
      });
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static AgencyLogo = async (data: any) => {
    try {
      const res = await axiosInstance.post(`agency/upload-agency-logo`, data);
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static UploadBrandLogo = async (data: any) => {
    try {
      const res = await axiosInstance.post(`agency/upload-brand-logo`, data);

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      return {
        error: err?.response?.data?.message || "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static RegisterAgency = async (data: any) => {
    try {
      const res = await axiosInstance.post(`agency/register/profile`, data);
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static updateAgencyProfile = async (data: any, agency_id: string) => {
    try {
      const res = await axiosInstance.put(
        `client/agency/update/${agency_id}`,
        data,
      );
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static saveAgencyDeclaration = async (data: {
    agency_id: string;
    declaration_type: string;
    is_accepted: boolean;
    metadata?: any;
  }) => {
    try {
      const res = await axiosInstance.post(
        `client/agency/agency-declarations`,
        data,
      );

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      return {
        error: err?.response?.data?.message || "Failed to save declaration",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static getAgencyDeclaration = async (params: {
    agency_id: string;
    declaration_type: string;
  }) => {
    try {
      const res = await axiosInstance.get(
        `client/agency/get-agency-declarations`,
        {
          params: {
            agency_id: params.agency_id,
            declaration_type: params.declaration_type,
          },
        },
      );

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      return {
        error:
          err?.response?.data?.message || "Failed to fetch agency declaration",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static AgencyInvitationLink = async (id: string) => {
    try {
      const res = await axiosInstance.post(
        `agent/get-invitation-link?inviter_id=${id}`,
      );
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static AgencyInvite = async (data: {
    invitee_email: string;
    inviter_id: string;
  }) => {
    try {
      const res = await axiosInstance.post(`agent/invite-agency`, data);
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static getClientSettings = async () => {
    try {
      const res = await axiosInstance.get(
        `client-settings/get-client-settings`,
      );

      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error:
          err.response?.data?.message || "Failed to fetch client settings.",
        data: err?.response?.data,
      };
    }
  };

  static updateClientSettings = async (payload: {
    recap_post_settings: object;
  }) => {
    try {
      const res = await axiosInstance.patch(
        `client-settings/update-client-settings`,
        payload,
      );
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error:
          err.response?.data?.message || "Failed to update recap settings.",
        data: err?.response?.data,
      };
    }
  };

  static getAgencyById = async (params: { agency_id: string }) => {
    try {
      const res = await axiosInstance.get(
        `agency/agency-details/${params.agency_id}`,
      );

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static getAgencyDetails = async () => {
    try {
      const res = await axiosInstance.get(`agency/agency-details`);

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static validateTaxId = async (data: {
    agency_id: string;
    value: string;
    type?: string;
  }) => {
    try {
      const res = await axiosInstance.post(`agency/validate-tax-id`, data);

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      return {
        error: err?.response?.data?.message || "Invalid Tax ID Number",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static createAgentProfile = async (data: any) => {
    try {
      const res = await axiosInstance.post(
        `agency/register/create-agent-profile`,
        data,
      );

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static getBrandList = async ({
    search,
    country_code,
  }: {
    search: string;
    country_code?: string;
  }) => {
    const countryCodeToName: Record<string, string> = {
      AU: "australia",
      NZ: "new_zealand",
    };

    const brand_country = country_code
      ? countryCodeToName[country_code.toUpperCase()] || ""
      : "";

    try {
      const res = await axiosInstance.get(`admin/brand`, {
        params: {
          search,
          page: 1,
          limit: 50,
          status: "active",
          ...(brand_country ? { brand_country } : {}),
        },
      });

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static sendBillingEmailOtp = async (data: {
    agency_id: string;
    email: string;
  }) => {
    try {
      const res = await axiosInstance.post(
        `agency/billing-email/send-otp`,
        data,
      );
      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      return {
        error: err?.response?.data?.message || "Failed to send OTP",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static verifyBillingEmailOtp = async (data: {
    agency_id: string;
    email: string;
    otp: string;
  }) => {
    try {
      const res = await axiosInstance.post(
        `agency/billing-email/verify-otp`,
        data,
      );
      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      return {
        error: err?.response?.data?.message || "Invalid OTP",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static getAgencyRejectionReason = async (agency_id: string) => {
    try {
      const res = await axiosInstance.get(
        `agency/${agency_id}/rejection-reason`,
      );

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.response?.status;

      // if (status === 401) {
      //   toast.error("Unauthorized, please login!");
      //   window.location.href = clientRoutes.login;
      // }

      return {
        error:
          err?.response?.data?.message ||
          "Something went wrong while fetching rejection reason!",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static checkPhoneAvailability = async (data: {
    principal_agent_mobile_number: string;
    phone_country_code?: string;
  }) => {
    try {
      const res = await axiosInstance.post(
        `agency/check-phone-availability`,
        data,
      );

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      return {
        error:
          err?.response?.data?.message ||
          "This mobile number is already in use.",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static checkAgencyNameAvailability = async (data: {
    agency_trading_name?: string;
    agency_legal_name?: string;
    country_code: string;
    exclude_agency_id?: string;
  }) => {
    try {
      const res = await axiosInstance.post(
        `agency/check-name-availability`,
        data,
      );

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      return {
        error:
          err?.response?.data?.message ||
          "Failed to check agency name availability",
        data: err?.response?.data,
        success: false,
      };
    }
  };
}
